import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTranslation } from "react-i18next";
import { driver, type DriveStep } from "driver.js";
import "driver.js/dist/driver.css";

export interface DialogHelpStep {
  element?: string;
  title: string;
  description: string;
}

// Piccolo "?" da inserire nel titolo di una modale: avvia una guida driver.js
// SCOPED alla modale già aperta, evidenziando ogni campo/sezione. Solo descrittiva:
// non clicca pulsanti d'azione né esegue operazioni (nessun salva/elimina).
export function DialogHelp({ steps, label }: { steps: DialogHelpStep[]; label?: string }) {
  const { t } = useTranslation();

  const run = () => {
    const usable = steps.filter((s) => !s.element || document.querySelector(s.element as string));
    if (usable.length === 0) return;
    driver({
      showProgress: true,
      allowClose: true,
      overlayOpacity: 0.6,
      stagePadding: 6,
      stageRadius: 8,
      smoothScroll: true,
      animate: true,
      nextBtnText: t("help.next"),
      prevBtnText: t("help.prev"),
      doneBtnText: t("help.done"),
      steps: usable.map((s) => ({ element: s.element, popover: { title: s.title, description: s.description } }))
    }).drive();
  };

  return (
    <Tooltip title={label ?? t("help.button")}>
      <IconButton size="small" onClick={run} aria-label={label ?? t("help.button")} sx={{ ml: 0.5, color: "text.secondary" }}>
        <HelpOutlineIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}
